import { render, staticRenderFns } from "./LiveResult.vue?vue&type=template&id=68848c67&scoped=true&"
import script from "./LiveResult.vue?vue&type=script&lang=js&"
export * from "./LiveResult.vue?vue&type=script&lang=js&"
import style0 from "./LiveResult.vue?vue&type=style&index=0&id=68848c67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68848c67",
  null
  
)

export default component.exports